<template>
  <div class="menu__body">
    <div class="menu__info">
      <div class="box">
        <div class="box__head">{{ $t('Modal.MenuPersonal.msg9') }}</div>
        <div class="box__txt">{{ $t('Modal.MenuPersonal.msg10') }}</div>
        <div class="box__lst">
          <ul class="lst-allergy" v-if="this.itemObj.ALLERGY_LIST != null && this.itemObj.ALLERGY_LIST.length != 0">
            <li v-for="alg in allergys.filter((item) => this.itemObj.ALLERGY_LIST.indexOf(item.COMM_CD) >= 0)" :key="alg">
              <span class="alle-item">{{ alg.COMM_CD_NM }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="box">
        <div class="box__head">{{ $t('Modal.MenuPersonal.msg11') }}</div>
        <div class="lst-wbox">
          <div class="wbox" v-if="itemObj.CAL != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg12') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.CAL }}</div>
          </div>
          <div class="wbox" v-if="itemObj.PROTEIN != 0 && itemObj.PROTEIN != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg13') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.PROTEIN }}</div>
          </div>
          <div class="wbox" v-if="itemObj.FAT != 0 && itemObj.FAT != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg14') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.FAT }}</div>
          </div>
          <div class="wbox" v-if="itemObj.TRANS != 0 && itemObj.TRANS != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg17') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.TRANS }}</div>
          </div>
          <div class="wbox" v-if="itemObj.CARBO != 0 && itemObj.CARBO != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg15') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.CARBO }}</div>
          </div>
          <div class="wbox" v-if="itemObj.SUGAR != 0 && itemObj.SUGAR != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg16') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.SUGAR }}</div>
          </div>
          <div class="wbox" v-if="itemObj.NAT != 0 && itemObj.NAT != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg18') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.NAT }}</div>
          </div>
          <div class="wbox" v-if="itemObj.CHOL != 0 && itemObj.CHOL != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg20') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.CHOL }}</div>
          </div>
          <div class="wbox" v-if="itemObj.CAFF != 0 && itemObj.CAFF != null">
            <div class="wbox-t">{{ $t('Modal.MenuPersonal.msg19') }}</div>
            <div class="ft--xlg ft--bold">{{ itemObj.CAFF }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'optionInfo',
  props: {
    optionInfoYn: Boolean,
    itemObj: Object,
  },
  methods: {},
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      allergys: this.$store.getters.getAllergys,
    };
  },
  mounted() {},
  components: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    optionInfoYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00104', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/lst-allergy.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
<style src="@/assets/css/user/dark/lst-allergy-dark.css" scoped></style>
<style scoped></style>
